import type { FC } from "react";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationSliderSheet } from "web_myplann/Inspiration/Components/InspirationSliderSheet";
import {
	OWN_HOME_EXPENSES_FALLBACK,
	OWN_HOME_EXPENSES_FIELD,
} from "web_myplann/Inspiration/OwnHome/constants";

const R = Resources.Inspiration.OwnHome.ExpensesSheet;

type Props = {
	open: boolean;
	initial?: number;
	onClose: () => void;
	onSubmit: (expenses: number) => void;
	onSaveToBilance: () => void;
};

export const ExpensesSheet: FC<Props> = ({
	open,
	initial,
	onClose,
	onSubmit,
	onSaveToBilance,
}) => (
	<InspirationSliderSheet
		open={open}
		copy={R}
		secondaryLabel={R.saveToBilance}
		onSecondary={onSaveToBilance}
		initial={initial ?? OWN_HOME_EXPENSES_FALLBACK}
		{...OWN_HOME_EXPENSES_FIELD}
		onClose={onClose}
		onSubmit={onSubmit}
	/>
);
